// Изменить дату в таблице
export const CAN_EDIT_OVP_DATE = 'CAN_EDIT_OVP_DATE';
